import { render, staticRenderFns } from "./dictSelect.vue?vue&type=template&id=6a8d2db5"
import script from "./dictSelect.vue?vue&type=script&lang=js"
export * from "./dictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports